
const LANG_MAP = {
    "se": "sv",
    "dk": "da",
    "fi": "fi",
    "no": "no"
  }
  

const addAnalytics = (market, category, subcategory) => {
    const hostname = window.location.hostname;
    if ( /localhost/.exec(hostname)){
        console.log("Localhost detected, skipping analytics");
       return null; 
    }

    const lang = LANG_MAP[market] || "sv";
    const env = /.uat./.exec(hostname) ? "DEV" : "Live";
    const url = env !== "Live" ? "https://tags.tiqcdn.com/utag/tui/tui-nd/qa/utag.js" : "https://tags.tiqcdn.com/utag/tui/tui-nd/prod/utag.js";


    const loadScript = async (url, callback) => {
      const script = document.createElement('script');
      script.src = url;
      script.type = 'text/javascript'; // Ensure correct MIME type
      script.async = true;
    
      // Attach callback to handle load or error events
      script.onload = callback;
      script.onerror = function () {
        console.error(`Failed to load script: ${url}`);
      };
    
      // Insert the script before the first script tag in the document
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(script, firstScript);
    }
    // Use the function to load the utag.js script
    const utagURL = "https://tags.tiqcdn.com/utag/tui/tui-nd/prod/utag.js";
    loadScript(utagURL, function () {
      console.log("Utag script loaded successfully");
    });
    
  
    let dataLayer = window.dataLayer || [];

    dataLayer.push ({ 
      "event": "pageData", 
      "page": { 
        "abTestV2": "", 
        "brand": `TUI ${market.toUpperCase()}`, 
        "country": `${market.toUpperCase()}`, 
        "environment": `TUI ${market.toUpperCase()}:${env}`, 
        "pageCategory": "Information", 
        "language": lang, 
        "pageError": "", 
        "pageID": "N/A", 
        "pageName":`TUI ${market.toUpperCase()}:Global:${category}:${subcategory}`, 
        "pageSubCategory": `${subcategory}`, 
        "pageURL": window.location.href, 
        "platform": "Northern Platform", 
        "siteSection": "Global"
      } });
    
      window.dataLayer = dataLayer;  
}


export default addAnalytics;